export default function GeneralDataProtectionRegulationContent() {
  return (
    <div className="p-3 flex flex-col space-y-3 whitespace-pre-wrap">
      <div className="font-bold text-center">
        INFORMACJE O PRZETWARZANIU DANYCH OSOBOWYCH - APLIKACJA „INVENIO HR”
      </div>
      <div className="text-justify">
        Osoby zainteresowane skorzystaniem z aplikacji „INVENIO HR” przekazują
        InvenioQD sp. z o.o. swój adres e-mail, który będzie wykorzystany mail
        do celów: logowania do aplikacji Invenio HR, komunikacji związanej z
        dostępem do systemu (np. reset hasła, powiadomienia systemowe),
        otrzymania linku aktywacyjnego oraz instrukcji pierwszego logowania.
      </div>
      <div className="text-justify">
        Administratorem danych osobowych w powyższym zakresie jest{" "}
        <strong>Invenio QD Sp. z o.o. z siedzibą w Tychach</strong> (43-100),
        ul. Fabryczna 2, wpisana do rejestru przedsiębiorców Krajowego Rejestru
        Sądowego pod numerem 0000465121 oraz legitymująca się numerem NIP
        6462930802; e-mail: tychy@invenio.pl (dalej jako „InvenioQD”). Wskazany
        adres jest adresem do kontaktu w kwestiach związanych z danymi
        osobowymi.
      </div>
      <div className="text-justify">
        Celem przetwarzania danych jest prawidłowe działanie aplikacji INVENIO
        HR, w tym zapewnienie możliwości logowania do aplikacji Invenio HR,
        komunikacji związanej z dostępem do systemu (np. reset hasła,
        powiadomienia systemowe), otrzymania linku aktywacyjnego oraz instrukcji
        pierwszego logowania.
      </div>
      <div className="text-justify">
        Przetwarzanie danych osobowych następuje w oparciu o zgodę osoby
        korzystającej z aplikacji. Przekazanie wypełnionego formularza „ZGODA NA
        PRZETWARZANIE ADRESU E-MAIL” stanowi jednocześnie <u>wyrażenie zgody</u>{" "}
        na przetwarzanie danych osobowych przez InvenioQD w powyższym zakresie.
        Zgoda może być odwołana w każdym czasie, przy czym odwołanie zgody nie
        ma wpływu na zgodność z prawem przetwarzania do czasu odwołania.
        Odwołanie zgody będzie się wiązać z brakiem możliwości korzystania z
        aplikacji.
      </div>
      <div className="text-justify">
        Można zgłosić sprzeciw wobec przetwarzania jego danych osobowych w każdy
        czasie.
      </div>
      <div className="text-justify">
        Do kategorii odbiorców danych osobowych Uczestników należeć mogą
        podmioty zajmujące się obsługa informatyczną InvenioQD.
      </div>
      <div className="text-justify">
        Dane osobowe zgromadzone w związku z aplikacją mogą być przechowywane
        przez InvenioQD przez okres, w jakim dana osoba korzysta z aplikacji,
        przy czym nie dłużej niż do dnia zakończenia okresu
        zatrudnienia/współpracy/innego stosunku prawnego związanego ze
        świadczeniem usług/pracy na rzecz InvenioQD.
      </div>
      <div className="text-justify">
        InvenioQD nie przewiduje automatycznego przetwarzania danych osobowych,
        w tym profilowania.
      </div>
      <div className="text-justify">
        Mają Państwo prawo żądania sprostowania, usunięcia lub ograniczenia
        przetwarzania swoich danych osobowych, a nadto przenoszenia danych
        osobowych oraz wniesienia sprzeciwu wobec ich przetwarzania oraz prawo
        do wniesienia skargi do organu nadzorczego, którym to jest Prezes Urzędu
        Ochrony Danych Osobowych (ul. Stawki 2, 00-193 Warszawa).
      </div>
    </div>
  );
}
